import React from "react";
import styles from "./NeonFond.module.css";
import {PALETTES, REGLAGES} from "./reglages";
import {graine} from "../arcade/sprites";
import {resoudre} from "../reglages";

/**
 * Fonds du thème Cyber-néon : trois ambiances de ville futuriste, en CSS pur (dessins et code originaux). Un seul composant,
 * trois variantes (`variante`) :
 *   grille  : soleil à rayures sur l'horizon et grille en perspective qui avance ;
 *   pluie   : traînées de lumière verticales au-dessus d'une ligne de tours aux fenêtres allumées ;
 *   circuit : impulsions lumineuses qui courent sur des lignes horizontales.
 * Tout bouge par `transform` ou `opacity` ; les positions sont tirées une fois avec une graine fixe.
 */
function Grille({palette}) {
    return (
        <>
            <div className={styles.soleil} style={{background: `linear-gradient(180deg, ${palette.soleil[0]}, ${palette.soleil[1]})`}}/>
            <div className={styles.plan}><div className={styles.quadrillage} style={{"--ligne": palette.neons[0]}}/></div>
        </>
    );
}

function Pluie({nombre, palette}) {
    const hasard = graine(41);
    const tours = Array.from({length: 14}, (_, i) => ({gauche: i * 7.2, hauteur: 12 + hasard() * 22}));
    return (
        <>
            {Array.from({length: nombre * 2}, (_, i) => (
                <div key={i} className={styles.trait} style={{left: `${hasard() * 99}%`, background: `linear-gradient(180deg, transparent, ${palette.neons[i % 2]})`,
                    animationDelay: `${-hasard() * 8}s`, animationDuration: `${2.5 + hasard() * 3}s`}}/>
            ))}
            <div className={styles.ville}>
                {tours.map((t, i) => (
                    <div key={i} className={styles.tour} style={{left: `${t.gauche}%`, height: `${t.hauteur}%`, "--fenetre": palette.neons[i % 2]}}/>
                ))}
            </div>
        </>
    );
}

function Circuit({nombre, palette}) {
    const hasard = graine(53);
    return Array.from({length: nombre}, (_, i) => (
        <div key={i} className={styles.piste} style={{top: `${4 + (i + hasard() * 0.6) * (92 / nombre)}%`, "--neon": palette.neons[i % 2]}}>
            <div className={styles.impulsion} style={{animationDelay: `${-hasard() * 9}s`, animationDuration: `${3 + hasard() * 4}s`}}/>
        </div>
    ));
}

const VARIANTES = {grille: Grille, pluie: Pluie, circuit: Circuit};

export default function NeonFond({variante = "grille", reglages}) {
    const r = resoudre(REGLAGES, reglages);
    const palette = PALETTES[r.palette] || PALETTES.violet;
    const Variante = VARIANTES[variante] || Grille;
    return (
        <div className={styles.scene} aria-hidden="true"
             style={{background: `linear-gradient(180deg, ${palette.haut}, ${palette.bas})`, "--vitesse": 1 / r.vitesse}}>
            <Variante nombre={r.nombre} palette={palette}/>
        </div>
    );
}

export const fondNeon = variante => function FondNeon(props) {
    return <NeonFond variante={variante} {...props}/>;
};
